import React from "react";
import { apiURL } from "../../../utlis/config";
import { Upload, Icon, Button } from "antd";
import store from "store";
const { Dragger } = Upload;

const imageUpload = (questionsProps) => {
  var { onChangeImage, removeImage, imageUrl, uploadType } = questionsProps;
  const uploadProps = {
    name: "file",
    multiple: false,
    action: `${apiURL}${"/media"}`,
    headers: {
      Authorization: `Bearer ${store.get("authToken")}`,
    },
    onChange(info) {
      const { status, response } = info.file;
      if (status !== "uploading") {
      }
      if (status === "done") {
        if (!response.error && response.status === 200) {
          console.log({
            response: apiURL + response.data,
          });
          // imageUrl = response.data;
          onChangeImage(response.data);
        }
      } else if (status === "error") {
        // that.showErrorMessage("Uploading failed. Please try again");
      }
    },
  };
  return (
    <div className="col-md-12" id="createQuizContainer">
      {!imageUrl ? (
        <Dragger {...uploadProps}>
          <p className="ant-upload-drag-icon">
            <Icon type="picture" />
          </p>
          <p className="uploadText">
            {`Click or drag image to this area to upload `}
          </p>
        </Dragger>
      ) : (
        <div className="imageContainer">
          <img
            className="imagePreview"
            src={`${apiURL}${imageUrl}`}
            alt="preview"
          />
          <Button
            className="closeBtn"
            shape="circle"
            icon="close"
            onClick={removeImage}
          />
        </div>
      )}
    </div>
  );
};
export default imageUpload;
